import { render, staticRenderFns } from "./MaterialCategoryTree.vue?vue&type=template&id=40c7a3c4&scoped=true"
import script from "./MaterialCategoryTree.vue?vue&type=script&lang=js"
export * from "./MaterialCategoryTree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c7a3c4",
  null
  
)

export default component.exports